module.exports = __webpack_public_path__ + "img/1436739085.b2f0e945.jpg";